module.exports = require('./config').VERSION
